/* eslint-disable no-undef */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable default-case */
import React, {
  Fragment,
  memo,
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils

// UI
import { Container, DateLayer } from "../Layout";

// Temp Images
import _T_CAMERA from "../../resources/images/icon/icon_camera_circle.png";

import { SUBS, SubMenu } from './Menu';



// const [prescriptionDate, setPrescriptionDate] = useState('');
// const [preparationDate, setPreparationDate] = useState('');
// const [hospitalName, setHospitalName] = useState('');
// const [pharmacyName, setPharmacyName] = useState('');
// const [prescriptionId, setPrescriptionId] = useState('');  // ?????????

const SET_PRESCRIPTION_DATE = 'SET_PRESCRIPTION_DATE';
const SET_PREPARATION_DATE = 'SET_PREPARATION_DATE';
const SET_HOSPITAL_NAME = 'SET_HOSPITAL_NAME';
const SET_PHARMACY_NAME = 'SET_PHARMACY_NAME';
const SET_EOCS_FILENAME = 'SET_EOCS_FILENAME';

(() => {
    window.__WEBVIEW_BRIDGE__= {
        init:function(e) {
            try {
                document.addEventListener("message", e=>alert(e.data));
            } catch (err) {
                // alert(err);
            }
        }
    };

    window.__WEBVIEW_BRIDGE__.init();
})();

const initialState = {
    prescriptionDate: '',
    preparationDate: '',
    hospitalName: '',
    pharmacyName: '',
    eocsFileName: '',
}

const reducer = (state, action) => {
    switch(action.type) {
        case SET_PRESCRIPTION_DATE:
            return {
                ...state,
                prescriptionDate: action.prescriptionDate
            }
        case SET_PREPARATION_DATE:
            return {
                ...state,
                preparationDate: action.preparationDate
            }
        case SET_HOSPITAL_NAME:
            return {
                ...state,
                hospitalName: action.hospitalName
            }
        case SET_PHARMACY_NAME:
            return {
                ...state,
                pharmacyName: action.pharmacyName
            }
        case SET_EOCS_FILENAME:
            return {
                ...state,
                eocsFileName: action.eocsFileName
            }
    }
}

// export function testApi() {jj
//     alert("hello")
// }

export default (props) => {
    const {userinfo, cfg, phonecfg} = useContext(AppContext);

    const [state, dispatch] = useReducer(reducer, initialState);

    const sub = SUBS[2];

    const [fileName, setFileName] = useState(props.match.params.fileName);

    // (() => {
    //     window.__WEBVIEW_BRIDGE__ = {
    //         init: function() {
    //             try {
    //                 document.addEventListener("message", e=>alert(e.data));
    //             } catch (err) {
    //                 alert(err);
    //             }
    //         }
    //     };

    //     window.__WEBVIEW_BRIDGE__.init();
    // })();

    const handlePictureFromApp1 = (fileName) => {
        dispatch({type: SET_EOCS_FILENAME, eocsFileName: fileName});
    }

    var exam_script1 = {
        test_js: function(fileName) {
            dispatch({type: SET_EOCS_FILENAME, eocsFileName: fileName});
        }
    }

    const handleDate = useCallback((isStart, date) => {
        // alert(props.match.params.fileName);

        if (isStart === "1") {
            dispatch({type: SET_PRESCRIPTION_DATE, prescriptionDate: date});
        } else {
            dispatch({type: SET_PREPARATION_DATE, preparationDate: date});
        }
    })

    const request202 = () => {
        if (state.hospitalName === '') {
            alert("병원명을 입력해주세요.");
            return;
        }

        if (state.filePath === '') {
            alert("처방전 파일을 등록해주세요.");
            return;
        }

        // PostApi202(userinfo, cfg, state.prescriptionDate, state.preparationDate, state.hospitalName, state.pharmacyName, state.filePath)
        //     .then(res => {
        //         console.log(res);
        //         if (res.resultMsg === 'SUCCESS' && res.result === '1') alert("성공");
        //         else alert("실패");
        //     })
        //     .catch(err => {
        //         console.log(err);
        //         alert("에러발생");
        //     });
    };

    return (
        <Fragment>
            {/* <Container Title={sub.label} bottom={list.length === 0 ? <Bottom /> : null}> */}
            <Container Title={sub.label} color="purple" >
                <div className="contents sub grad">
                    <SubMenu SUBS={SUBS} code={sub.code} phoneOs={phonecfg.phoneOS} />

                    {/* {list.length === 0 ? <Nothing /> : <Regist />} */}
                    <Regist myState={state} dispatch={dispatch} request202={request202} />
                </div>
            </Container>
            <DateLayer handleDate={handleDate} />
        </Fragment>
    );
};

const Regist = memo(( {myState, dispatch, request202} ) => {
    const {phonecfg} = useContext(AppContext);

    useEffect(() => {
        // //기간설정 버튼들
        // $(".date-setting-area .btns a").click(function () {
        //     $(".date-setting-area .btns a").removeClass("on");
        //     $(this).addClass("on");
        //     var idx = $(this).index();
        //     if (idx == 3) {
        //         //직접 기간설정
        //         $(".date-setting-area .date-input").slideDown("fast");
        //     } else {
        //         $(".date-setting-area .date-input").slideUp("fast");
        //     }
        // });
    }, []);

    const handleChange = (e) => {
        switch(e.target.name) {
            case 'hospitalName':
                dispatch({type:SET_HOSPITAL_NAME, hospitalName: e.target.value});
                break;
            case 'pharmacyName':
                dispatch({type:SET_PHARMACY_NAME, pharmacyName: e.target.value});
                break;
            default:
                return;
        }
    }

    const handleDeviceCamera = () => {
        try {
            if(phonecfg.phoneOS === "ANDROID") {
                window.java.takeEocsPicture()
            } else {
                webkit.messageHandlers.takeEocsPicture.postMessage();

            }
        } catch (err) {
            alert("단말기에서 테스트 하세요.");
        };
    }

    const handleEocsCancel = () => {
        // setEocsLocalFile('a')
    }

    const handleEocsConfirm = () => {
        request202();
    }

    var exam_script = {
        test_js: function(fileName) {
            dispatch({type: SET_EOCS_FILENAME, eocsFileName: fileName});
        }
    }

    const handlePictureFromApp = (fileName) => {
        dispatch({type: SET_EOCS_FILENAME, eocsFileName: fileName});
    }

    return (
      <div className="sub-contents">
        <div className="pr-section">
          <div className="sub-title">종이처방전 등록</div>
          <div className="device-state-info">아래의 정보를 입력해주세요.</div>

          <div className="gr-half-boxes">
            <div>
              <div className="tit">처방일</div>
              <div>
                <input
                  type="text"
                  name="prescriptionDate"
                  className="textbox date-picker-input pick-num1"
                  data-num="1"
                  placeholder="처방일을 선택해주세요."
                  readOnly
                />
              </div>
            </div>
            <div>
              <div className="tit">조제일</div>
              <div>
                <input
                  type="text"
                  name="preparationDate"
                  className="textbox date-picker-input pick-num2"
                  data-num="2"
                  placeholder="조제일을 선택해주세요."
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="medic-input-page">
            <div>
              <input
                type="text"
                className="textbox"
                name="hospitalName"
                onChange={handleChange}
                placeholder="병원명을 입력해주세요."
              />
            </div>
            <div>
              <input
                type="text"
                className="textbox"
                name="pharmacyName"
                onChange={handleChange}
                placeholder="약국명을 입력해주세요."
              />
            </div>
          </div>

          <div className="in-put-camera">
            {myState.eocsFileName === "" ? (
              <a href={void 0} onClick={(e) => handleDeviceCamera()}>
                <img src={_T_CAMERA} alt="Camera Icon" />
                <p>처방전을 등록해주세요.</p>
              </a>
            ) : (
              <img
                src="file:///data/user/0/kr.co.mdpeople.eocs/files/20210205074306546.jpg"
                alt="처방전 파일"
              />
            )}
          </div>
        </div>

        <div className="pr-section">
          <div className="two-btns-area">
            <a onClick={(e) => handleEocsCancel()}>취소</a>
            <a onClick={(e) => handleEocsConfirm()}>확인</a>
          </div>
        </div>
      </div>
    );
});

// const Bottom = () => {
//     return (
//         <div className="under-fix-btnarea">
//             <Link to="/sm/bp/input" className="btn-inputok">
//                 <i></i>입력
//             </Link>
//         </div>
//     );
// };

// const Nothing = (props) => {
//     return (
//         <div className="sub-contents">
//             <div className="nothing-box">
//                 <div>
//                     <img src={IC.empty.bp} alt="" />
//                     <p>
//                         입력하신 정보가 없습니다.
//                         <br />
//                         혈압정보를 입력해 주세요.
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// };
